import { createApi } from '@reduxjs/toolkit/query/react';
import {
  CompleteQaIntegrationRequestDto,
  QaDetail,
  QaIntegrationRequestDto,
  QaList,
  ResponseDto,
  UpdateQaIntegrationRequestDto
} from 'types';
import axiosBaseQuery from 'utils/base-api';

export const qaIntegrationApi = createApi({
  reducerPath: 'qaIntegrationApi',
  tagTypes: [],
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    getQaIntegrationList: builder.query<ResponseDto<QaList[]>, QaIntegrationRequestDto>({
      query: (params) => ({
        url: '/qa_integration/qa_list',
        method: 'get',
        params
      })
    }),

    getQaIntegrationDetail: builder.query<ResponseDto<QaDetail>, number>({
      query: (evaluationId) => ({
        url: `/qa_integration/detail/${evaluationId}`,
        method: 'get'
      })
    }),

    postQaIntegrationUpdate: builder.mutation<ResponseDto<QaDetail>, UpdateQaIntegrationRequestDto>({
      query: ({ evaluationId, responseContent }) => ({
        url: `/qa_integration/update`,
        method: 'post',
        data: { evaluationId, responseContent }
      })
    }),

    postQaIntegrationComplete: builder.mutation<ResponseDto<QaDetail>, CompleteQaIntegrationRequestDto>({
      query: ({ evaluationId, responseContent, agent }) => ({
        url: `/qa_integration/complete`,
        method: 'post',
        data: { evaluationId, responseContent, agent }
      })
    })
  })
});

export const {
  useGetQaIntegrationListQuery,
  useGetQaIntegrationDetailQuery,
  usePostQaIntegrationUpdateMutation,
  usePostQaIntegrationCompleteMutation
} = qaIntegrationApi;
